import { IFsNodeSchema } from '@cloudike/web_files'
import { BoardToolbarAction } from 'shared/constants/toolbar'

import { PUBLIC_LINK_PATHS, TARGET_CLASS_NAMES } from '../constants/publicFiles'
import { MouseSelectResult, SelectedItemWithType } from '../types/publicFiles'

export const buildPublicLinkPath = (paths: string[]): string => {
  return `${PUBLIC_LINK_PATHS.BASE}/${paths.join('/')}`
}

export const processMouseSelection = (
  result: MouseSelectResult[],
  subBoards: IFsNodeSchema[],
  assets: IFsNodeSchema[]
): {
  selectedAssets: SelectedItemWithType[]
  selectedBoards: SelectedItemWithType[]
  selectedAssetsIds: string[]
  selectedBoardsIds: string[]
} => {
  const selectedItems = result.map((item) => {
    if (item.targetClassName === TARGET_CLASS_NAMES.BOARD_CARD) {
      const board = subBoards.find((board) => board.id === item.id)
      return {
        ...board,
        itemType: 'board' as const,
      }
    } else if (item.targetClassName === TARGET_CLASS_NAMES.ASSET_CARD) {
      const asset = assets.find((asset) => asset.id === item.id)
      return {
        ...asset,
        itemType: 'asset' as const,
      }
    }
    return null
  }).filter(Boolean) as SelectedItemWithType[]

  const selectedAssets = selectedItems.filter((item) => item.itemType === 'asset')
  const selectedBoards = selectedItems.filter((item) => item.itemType === 'board')
  
  return {
    selectedAssets,
    selectedBoards,
    selectedAssetsIds: selectedAssets.map((asset) => asset.id),
    selectedBoardsIds: selectedBoards.map((board) => board.id),
  }
}

export const createPermissionFilter = (
  isDownloadEnabled: boolean,
  isEditContentEnabled: boolean,
) => {
  return (actions: any[]) => {
    return actions.filter((action) => {
      if (!action) return false
      
      const actionName = action.key || action.id

      if (actionName === BoardToolbarAction.Download && !isDownloadEnabled) {
        return false
      }
      
      if ((actionName === BoardToolbarAction.Rename
        || actionName === BoardToolbarAction.RemoveFromBoard
        || actionName === BoardToolbarAction.Move
        || actionName === BoardToolbarAction.AddToAnotherBoard
        || actionName === BoardToolbarAction.Copy
        || actionName === BoardToolbarAction.Duplicate) && 
          !isEditContentEnabled) {
        return false
      }
      
      return true
    })
  }
}

export const createEnhancedBreadcrumbs = (
  breadcrumbs: any[],
  paths: string[],
  navigate: (path: string) => void
) => {
  if (!breadcrumbs.length) return []

  return breadcrumbs.map((crumb) => {
    const id = crumb.id ?? ''
    const pathUpToCrumb = paths.slice(0, paths.indexOf(id) + 1)
    const crumbPath = buildPublicLinkPath(pathUpToCrumb)

    return {
      ...crumb,
      onClick: () => navigate(crumbPath),
    }
  })
}

export const getCurrentBoardData = (breadcrumbs: any[], nodeData: any) => {
  return breadcrumbs.length > 1 
    ? breadcrumbs[breadcrumbs.length - 1].data 
    : nodeData
}

export const isModifierKey = (key: string): 'ctrl' | 'shift' | null => {
  if (key === 'Meta' || key === 'Control') {
    return 'ctrl'
  }
  if (key === 'Shift') {
    return 'shift'
  }
  return null
}

export const getTargetClassNames = () => [
  TARGET_CLASS_NAMES.BOARD_CARD,
  TARGET_CLASS_NAMES.ASSET_CARD,
]